import React from 'react';
import EndpointWorkbench from '../components/EndpointWorkbench';
import { endpointService } from '../services/endpointService';

const AIProcessPage: React.FC = () => {
  return (
    <EndpointWorkbench
      title="AI Sorgu At"
      subtitle="Eksik veya kısa hata açıklamalarını yaratıcı AI ile zenginleştiren endpointi ayrı bir sayfada yönetin; request/response ve history kayıtları birlikte izlenir."
      endpointBadge="/api/aiprocess/query"
      accent="aiprocess"
      queryButtonLabel="AI Sorgu At"
      historyTitle="AI Sorgu At Geçmişi"
      historySubtitle="Dış servisin history’e yazdığı kayıtlar pagination ile listelenir; detay açıldığında request ve response blokları ayrı görünür."
      presets={[
        'kapı ses',
        'multimedya sorun',
        'bagaj su alıyor'
      ]}
      queryPlaceholder="Eksik ya da kısa hata açıklamasını yazın..."
      historyEmptyText="Henüz AI Sorgu At kaydı bulunmuyor."
      latestEmptyText="AI Sorgu At çalıştırıldığında son yanıt burada görünecek."
      historyLagNote="Yeni kayıtlar dış servis log akışı nedeniyle birkaç saniye gecikmeli listeye düşebilir."
      query={endpointService.queryAIProcess}
      loadHistory={endpointService.getAIProcessHistory}
    />
  );
};

export default AIProcessPage;
